module.exports = __webpack_public_path__ + "img/architectureImg4.5cd5605f.jpeg";